import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import './Page2.css';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';

function Players() {
  const navigate = useNavigate();

  const [striker, setStriker] = useState('');
  const [nonStriker, setNonStriker] = useState('');
  const [bowler, setBowler] = useState('');
  const [matchId, setMatchId] = useState('');

  useEffect(() => {
    const storedMatchId = localStorage.getItem('match_id');
    if (storedMatchId) {
      setMatchId(storedMatchId);
    } else {
      alert('Match ID not found. Please start from the beginning.');
      navigate('/');
    }
  }, []);

  const handleStartMatch = async () => {
    if (!striker || !nonStriker || !bowler) {
      alert('Please enter all players');
      return;
    }

    try {
      const response = await axios.post('https://nammateam.onrender.com/players/setup', {
        match_id: matchId,
        striker,
        non_striker: nonStriker,
        bowler
      });
localStorage.setItem("matchset","true");
      if (response.data.success) {
        navigate('/live');
      } else {
        alert('Failed to save players. Please try again.');
      }
    } catch (err) {
      console.error('Error saving players:', err);
      alert('Server error occurred. Please check the backend.');
    }
  };

  return (
    <div className="players-container">
      <div className="players-header">
        <p><FontAwesomeIcon icon={faArrowLeft} /> Select Opening Players</p>
      </div>

      <div className="player-section">
        <h4>Striker</h4>
        <input
          type="text"
          placeholder="Enter striker name"
          className="player-input"
          value={striker}
          onChange={(e) => setStriker(e.target.value)}
        />
        <hr />
      </div>

      <div className="player-section">
        <h4>Non-Striker</h4>
        <input
          type="text"
          placeholder="Enter non-striker name"
          className="player-input"
          value={nonStriker}
          onChange={(e) => setNonStriker(e.target.value)}
        />
        <hr />
      </div>

      <div className="player-section">
        <h4>Opening Bowler</h4>
        <input
          type="text"
          placeholder="Enter bowler name"
          className="player-input"
          value={bowler}
          onChange={(e) => setBowler(e.target.value)}
        />
        <hr />
      </div>

      <button className="players-btn" onClick={handleStartMatch}>
        Start Match
      </button>
    </div>
  );
}

export default Players;
